import styled from 'styled-components';

export const Item = styled.div`
  margin: 8px 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  span {
    font-size: 12px;
    color: #4d4d4d;
    padding: 8px;
    padding-left: 8px;

    &.labelWithIcon {
      justify-content: space-between;
      align-items: center;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding-top: 2.5px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const ItemContent = styled.div`
  border: 2px solid #4d4d4d;
  padding: 0px 8px;
  border-radius: 4px;
  height: 40px;
  width: calc(100% - 20px);
  display: flex;
  align-items: center;

  transition: 0.3s;
  .iconeRenegociacao {
    margin-right: 8px;
  }

  span {
    padding: 0;
  }

  input {
    margin: 0;
    border: 0;
    height: 100% - 8px;
    width: 100%;
    font-weight: bold;
    outline: none;

    transition: 0.3s;
  }

  input,
  .currency {
    font-size: 13px;
    font-weight: bold;
  }
`;

export const SimularButton = styled.button`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
  border: none;
  color: #ffffff;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s;
  background-color: ${({ tema }) => tema.primaryColor};

  &:disabled {
    background-color: #d1d1d1;
    cursor: auto;
  }
`;
